import { createIcon } from '@chakra-ui/react';

export const SortUpDownArrowIcon = createIcon({
  displayName: 'SortUpDownArrowIcon',
  viewBox: '0 0 16 16',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <>
      <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M10.9475 9.6816L10.9476 9.68147C10.979 9.65009 11.0215 9.63245 11.0659 9.63244C11.1102 9.63242 11.1528 9.65003 11.1842 9.68139C11.2155 9.71275 11.2332 9.75529 11.2332 9.79965C11.2332 9.84402 11.2156 9.88657 11.1842 9.91795L8.31776 12.7844C8.2865 12.8157 8.24412 12.8332 8.19992 12.8332C8.15573 12.8332 8.11334 12.8157 8.08209 12.7844L5.21573 9.91807C5.2157 9.91805 5.21567 9.91802 5.21564 9.91799C5.1843 9.88656 5.16672 9.84398 5.16675 9.79959C5.16678 9.75517 5.18446 9.71257 5.21589 9.68118C5.24733 9.64979 5.28995 9.63217 5.33438 9.6322C5.3788 9.63223 5.4214 9.64991 5.45279 9.68135L5.45299 9.68155L7.84632 12.0755L8.19987 12.4292L8.55348 12.0756L10.9475 9.6816Z'
          fill='black'
          stroke='black'
        />
        <path
          d='M10.9475 6.31828L10.9476 6.31841C10.979 6.34979 11.0215 6.36742 11.0659 6.36744C11.1102 6.36746 11.1528 6.34985 11.1842 6.31849C11.2155 6.28713 11.2332 6.24459 11.2332 6.20023C11.2332 6.15586 11.2156 6.11331 11.1842 6.08193L8.31776 3.21544C8.31774 3.21542 8.31772 3.2154 8.3177 3.21539C8.28645 3.18417 8.24409 3.16664 8.19992 3.16664C8.15576 3.16664 8.11339 3.18417 8.08214 3.21539C8.08213 3.2154 8.08211 3.21542 8.08209 3.21544L5.21573 6.0818C5.21569 6.08184 5.21566 6.08187 5.21562 6.08191C5.1843 6.11333 5.16672 6.15591 5.16675 6.20029C5.16678 6.24471 5.18446 6.2873 5.21589 6.3187C5.24733 6.35009 5.28995 6.36771 5.33438 6.36768C5.3788 6.36764 5.4214 6.34997 5.45279 6.31853L5.45299 6.31833L7.84632 3.92433L8.19987 3.57068L8.55348 3.92428L10.9475 6.31828Z'
          fill='black'
          stroke='black'
        />
      </svg>
    </>
  ),
});
